import React from 'react'
import cn from 'classnames'
import s from './LanguageDropdown.module.scss'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { Dropdown } from '@corratech/pylot-dropdown'
import { ChevronDown, ChevronUp } from 'react-feather'

type LanguageDropdownProps = {
    className?: string
    isOpen?: boolean
    setIsOpen?: (newIsOpen: boolean) => void
}

export const LanguageDropdown: React.FC<LanguageDropdownProps> = (props) => {
    const { t } = useTranslation(['common'])
    const { isOpen, setIsOpen } = props
    const {
        locale,
        locales,
        defaultLocale = 'en-US',
        asPath: currentPath
    } = useRouter()
    const options = locales?.filter((val) => val !== locale)

    const currentLocale = locale || defaultLocale

    const dropdownLabel = (isOpen: boolean) => (
        <button className={s['dropdown-button']}>
            <span>{t(`localeNames|${currentLocale}`)}</span>
            <span className={s['select-icon']}>
                {isOpen ? <ChevronDown size={15} /> : <ChevronUp size={15} />}
            </span>
        </button>
    )
    return (
        <nav className={s.root}>
            <div
                className={cn(
                    s['dropdown-content'],
                    'animate-fade-in-up',
                    props.className
                )}
            >
                <div className={s.list}>
                    <h3>{t('lang|Preferred Language')}</h3>
                    <Dropdown
                        openedDisplay={dropdownLabel(false)}
                        closedDisplay={dropdownLabel(true)}
                    >
                        <ul>
                            {options &&
                                options.map((locale) => (
                                    <li
                                        key={locale}
                                        className={s.item}
                                        onClick={() =>
                                            setIsOpen && setIsOpen(!isOpen)
                                        }
                                        aria-hidden="true"
                                    >
                                        <Link
                                            href={currentPath}
                                            locale={locale}
                                        >
                                            {t(`localeNames|${locale}`)}
                                        </Link>
                                    </li>
                                ))}
                        </ul>
                    </Dropdown>
                </div>
            </div>
        </nav>
    )
}
export default LanguageDropdown
